export default {
    data: {
        user: null,
        role: null,
        productList: null,
        PCXData: null
    },
    couponAvailable: 1, // 优惠券可用的flag
    mainUrl:null, // 域名
    mainId: null // 主体（分账记录）id
}



// WEBPACK FOOTER //
// ./src/store/state.js